module.exports = __webpack_public_path__ + "img/internal-documents_0.3faab4e4.svg";